import { useSelector } from 'react-redux'
import { HtmlParser } from '@calendly/html-parser'
import { Link } from '@calendly/ui/components/link'
import { IconAlertCircleFilled } from '@calendly/ui/components/glyphs/IconAlertCircleFilled'
import { UiIcon } from '@calendly/ui/components/ui-icon'
const colorTextWarning = 'var(--colorTextWarning, var(--coreColorOrange700))'

import { useI18n } from 'locales'
import { currentUserSelector } from 'selectors/user'

import { ErrorWarning as Container } from './styles'

const CalendarConnectionsLink = ({ children }) => {
  const url = '/app/availability/connected_calendars'

  return <Link underline={false} href={url} target="_blank" rel="opener">{children}</Link>
}

export default () => {
  const { i18n } = useI18n()
  const { locale } = useSelector(currentUserSelector)
  return (
    <Container>
      <UiIcon icon={IconAlertCircleFilled} size="small" color={colorTextWarning} />
      <div>{HtmlParser(i18n.t('publisher.mutual_availability.calendar_error', { locale }), { CalendarConnectionsLink })}</div>
    </Container>
  )
}
